export default __webpack_public_path__ + "static/media/front-img.09e9d2b5.jpg";